import React from 'react';
import PropTypes from 'prop-types';
import ReportCardSummary from '../ReportCardSummary/index';

import styles from './OperationalReports.module.css';

import { useAnalytics } from 'hooks/useAnalytics';

const detailsShape = PropTypes.shape({
  listItems: PropTypes.array.isRequired,
}).isRequired;

const propTypes = {
  cardDetails: PropTypes.shape({
    identifier: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    linkTarget: PropTypes.string.isRequired,
    details: detailsShape,
  }).isRequired,
};

function OperationalReportCard({ cardDetails }) {
  const { handleItemClick, handleKeystroke } = useAnalytics(
    'rlp-operational-reports',
    'select-report',
    cardDetails.identifier
  );

  return (
    <a
      className={styles['report-card']}
      onClick={handleItemClick}
      onKeyUp={handleKeystroke}
      href={cardDetails.linkTarget}
    >
      <ReportCardSummary cardDetails={cardDetails} />
    </a>
  );
}

OperationalReportCard.propTypes = propTypes;

export default OperationalReportCard;
